module.exports = __webpack_public_path__ + "img/icon-28.2c2092cf.svg";